import React from 'react';
import './ClientTestimonials.css';
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import Hero from '../../../components/home/Hero/Hero';

import featuredIcons1 from '../../../assets/images/clientsTestimonials/feauturedIcon1.svg'
import featuredIcons2 from '../../../assets/images/clientsTestimonials/feauturedIcon2.svg'
import featuredIcons3 from '../../../assets/images/clientsTestimonials/feauturedIcon3.svg'
import featuredIcons4 from '../../../assets/images/clientsTestimonials/feauturedIcon4.svg'
import globalItemsImg from '../../../assets/images/about/offshore-advisory-background.png'
import recommendedIcon1 from '../../../assets/images/clientsTestimonials/recommendedItemIcon1.svg'
import recommendedIcon2 from '../../../assets/images/clientsTestimonials/recommendedItemIcon2.svg'
import recommendedIcon3 from '../../../assets/images/clientsTestimonials/recommendedItemIcon3.svg'
import recommendedIcon4 from '../../../assets/images/clientsTestimonials/recommendedItemIcon4.svg'
import { Link } from 'react-router-dom';
import Footer from '../../../components/Footer/Footer';




export default function ClientTestimonials() {
    const featuredStories = [
        {
            emoji: featuredIcons1,
            category: "iGaming Operator",
            title: "Western Sahara License",
            quote: '"We were unsure which jurisdiction to choose for our iGaming platform. Offshore Advisory guided us through Western Saharas licensing, handled all the paperwork, and got us operational faster than expected."',
            author: "Mark T.",
            position: "CEO of GlobalBet Ltd.",
            color: "#8b5cf6"
        },
        {
            emoji: featuredIcons2,
            category: "Forex Brokerage",
            title: "Cyprus Setup",
            quote: '"The Offshore Advisory team helped us secure a CySEC Forex license in Cyprus. Their step-by-step compliance guidance made a complex process straightforward."',
            author: "Elena K.",
            position: "Director of FXProTrade",
            color: "#3b82f6"
        },
        {
            emoji: featuredIcons3,
            category: "Banking Project",
            title: "Mauritius",
            quote: '"Our group established a Mauritius Global Business Company (GBC) with banking permissions. Offshore Advisory gave us clarity, structure, and connected us with regulators."',
            author: "Rajesh P.",
            position: "Fund & Banking Manager",
            color: "#10b981"
        },
        {
            emoji: featuredIcons4,
            category: "Asset Protection",
            title: "UAE Residency",
            quote: '"I wanted a safe residency solution for my family and better tax planning. Offshore Advisory structured our UAE Free Zone company and secured residency visas for all of us."',
            author: "Ahmed A.",
            position: "Investor & Entrepreneur",
            color: "#f59e0b"
        }
    ];

    const breadcrumbs = [
    { name: 'Home', link: '/' },
    { name: 'Client Testimonials', link: '/client-testimonials' },
  ];

    const quickQuotes = [
        { quote: '"Professional, transparent, and fast — everything we needed."', author: "Laura M.", position: "FinTech Founder" },
        { quote: '"Their knowledge of gaming licenses across multiple jurisdictions is unmatched."', author: "David R.", position: "Gaming Entrepreneur" },
        { quote: '"We felt secure working with a team that always put compliance first."', author: "Sofia L.", position: "Asset Manager" },
        { quote: '"The process was smooth from day one. Highly recommended."', author: "Chen W.", position: "Crypto Exchange Founder" }
    ];

    const benefits = [
        { title: "Fast & Efficient", desc: "smooth processes, no delays.", img: recommendedIcon1},
        { title: "Trusted Globally", desc: "respected in 20+ jurisdictions.", img: recommendedIcon2 },
        { title: "End-to-End Support", desc: "from company setup to residency.", img: recommendedIcon3 },
        { title: "Compliance-Focused", desc: "safe, secure, and transparent.", img: recommendedIcon4 }
    ];

    return (
        <main className='main'>
            <Hero breadcrumbs={breadcrumbs} colorContent='black' backgroundImg='clientTestimonialHeader' title='Hear From Our Global Clients' descr="At Offshore Advisory, we measure our success by the success of our clients. From entrepreneurs and startups to banks, brokers, and gaming operators, we've helped hundreds of businesses and individuals achieve their international goals." contentCenter={true} />
              <div className='feautured-section-background'>
                        <div className='feautured-container'>
                            <h2 className='feautured-title'>
                                Featured Client Stories
                            </h2>
                            <div className='feaututerd-section-items-row'>
                                {featuredStories.map((item) => (
                                     <div className='feautured-section-item'>
                                        <div className='feautured-img-wrapper'>
                                            <img src={item.emoji} alt='#' />
                                        </div>
                                        <span className='feautured-item-section'>
                                            {item.category}
                                        </span>
                                        <h3 className='feautured-item-title'>
                                            {item.title}
                                        </h3>
                                        <p className='feautered-item-descr'>
                                            {item.quote}
                                        </p>
                                        <hr />
                                        <span className='feautered-item-author'>
                                            {item.author}
                                        </span>
                                        <span className='feautured-item-position'>
                                            {item.position}
                                        </span>
                                    </div>
                                ))}
                               
                            </div>
                        </div>
              </div>
              <div className='quick-quotes-container'>
                <h2 className='quick-quotes-title'>
                  Quick Quotes
                </h2>
                 <div className='quick-quotes-items-row'>
                    {quickQuotes.map((item) => (
                        <div className='quick-quotes-item'>
                        <p className='quick-quotes-descr'>
                        {item.quote}
                        </p>
                        <span className='quick-quotes-author'>
                            {item.author}
                        </span>
                        <span className='quick-quotes-point'>
                            {item.position}
                        </span>
                    </div>
                    ))}
                        
                 </div>
              </div>
              <div className='clients-recommended-background'>
                <div className='clients-recommended-container'>
                    <h2 className='clients-recommended-title'>
                        Why Clients Recommend Offshore Advisory
                    </h2>
                    <div className='recommended-keys-row'>
                        {benefits.map((item) => (
                            <div className='recommended-item-key'>
                                <div className='recommended-img-wrapper'>
                                    <img src={item.img} />
                                </div>
                                <div className='recommended-item-content'>
                                    <h3 className='recommended-item-title'>
                                        {item.title}
                                    </h3>
                                    <span className='recommended-item-descr'>
                                        {item.desc}
                                    </span>
                                </div>
                            </div>
                        ))}
                        
                    </div>
                </div>
              </div>
              <div className='join-our-global-background'>
                <div className='join-our-global-container'>
                    <div className='join-our-global-left'>
                       <div className='content-upper'>
                         <h2 className='join-our-global-title'>
                            Join Our Global Clients Today
                            </h2>
                            <p className='join-our-global-descr'>
                                Whether you're building an iGaming platform, brokerage, or fintech venture, or seeking residency & tax planning, Offshore Advisory is your trusted partner.
                            </p>
                       </div>
                        <div className='join-global-btn'>
                            <Link to='/newsletter'>
                                Get Started Today
                                <img src='' />
                            </Link>
                        </div>
                    </div>
                    <div className='join-our-global-right'>
                        <img src={globalItemsImg} />
                    </div>
                </div>

              </div>
              {/* <Footer /> */}
        </main>
    );
}
